import React from 'react';
import PropTypes from 'prop-types';
import { SketchPicker } from 'react-color';
import CommonPopup from 'components/common/CommonPopup';

import './IconColorPicker.css';

const IconColorPicker = ({ color, onChangeComplete }) => {
  return (
    <CommonPopup
      className="icon-color-picker__component"
      visibleBy="click"
      trigger={
        <div
          className="icon-color-select-button"
          role="button"
          tabIndex={-1}
          style={color && {
            backgroundColor: `${color}`,
          }}
        >
          <div className="color">{color}</div>
        </div>
      }
    >
      <SketchPicker
        color={color}
        onChangeComplete={onChangeComplete}
        disableAlpha
      />
    </CommonPopup>
  );
};

IconColorPicker.propTypes = {
  onChangeComplete: PropTypes.func,
  color: PropTypes.string.isRequired,
};

IconColorPicker.defaultProps = {
  onChangeComplete: null,
};

export default IconColorPicker;
